import React from "react";
import loadable from "@loadable/component";
import BottomSheet from "_c/BottomSheet";

const SaloonMasterPicker = loadable(
  () => import(/* webpackChunkName: "saloon-master-picker-modal" */ "./main"),
  { ssr: false }
);
const Modal = ({ isOpen, ...props }) => {
  const onClose = () => props.onClose();
  return (
    <BottomSheet
      defaultHeight={window.innerHeight * 0.75}
      isOpen={isOpen}
      onClose={onClose}
      header={<div />}
    >
      <div
        css={`
          color: var(--font-color-main);
          padding: 10px;
        `}
      >
        <SaloonMasterPicker {...props} onClose={onClose} />
      </div>
    </BottomSheet>
  );
};
export default Modal;
